
const calendari18n = ()=> {

    function getMonths(){
        try {
            return window?.ContentsAll?.ctn_4hwhZ1?.split(',') ?? ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        } catch (error) {
            return ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        }
    }

    function getMonthsShort(){
        try {
            return window?.ContentsAll?.ctn_hEGra9?.split(',') ?? ['Ene','Feb','Mar','Abr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dic'];
        } catch (error) {
            return ['Ene','Feb','Mar','Abr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dic'];
        }
    }

    function getWeekdays(){
        try {
            return window?.ContentsAll?.ctn_FS9ZZz?.split(',') ?? ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
        } catch (error) {
            return ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
        }
    }

    function getWeekdaysShort(){
        try {
            return window?.ContentsAll?.ctn_yaYQow?.split(',') ?? ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];
        } catch (error) {
            return ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];
        }
    }

    function getWeekdaysAbbrev(){
        try {
            return window?.ContentsAll?.ctn_wNyGq_?.split(',') ?? ['D','L','M','M','J','V','S'];
        } catch (error) {
            return ['D','L','M','M','J','V','S'];
        }
    }

    return {
        months: getMonths(),
        monthsShort: getMonthsShort(),
        weekdays: getWeekdays(),
        weekdaysShort: getWeekdaysShort(),
        weekdaysAbbrev: getWeekdaysAbbrev()
    }
}

export { calendari18n }